// Time in the app, for Usage (admins only): once a minute, while the page is visible and someone touched it in the
// last minute, the server hears "in use". Nothing else is sent; people never see these numbers.
import { useEffect } from 'react';
import { api } from '../api';

export function usePresence() {
  useEffect(() => {
    let last = Date.now();
    const touch = () => { last = Date.now(); };
    const events = ['pointerdown', 'keydown', 'wheel', 'touchstart'] as const;
    for (const e of events) window.addEventListener(e, touch, { passive: true });
    const tick = () => { if (document.visibilityState === 'visible' && Date.now() - last < 60_000) void api.presence().catch(() => undefined); };
    tick();
    const t = window.setInterval(tick, 60_000);
    return () => { window.clearInterval(t); for (const e of events) window.removeEventListener(e, touch); };
  }, []);
}
